import {ReportFilterBase} from './reportFilter/reportFilterBase';

export class ReportDefinition {


    filter:Array<ReportFilterBase> = [];

    addMetadata:boolean;

    includeImages:boolean;


    constructor() {
    }

    refresh() {
        this.filter = [];
    }

}
